import React, { Component } from 'react'
import './ViewDetails.css'
import * as languageSettings from '../components/Language/languageSettings'
import SystemSettings from '../components/Stores/SystemSettings'
import SystemStatus from '../components/Stores/SystemStatus'
import RemoteSystemActions from '../components/Stores/RemoteSystemActions'
import { connect } from 'react-redux'
import 'url-search-params-polyfill'
import { getStoreDetails } from '../actions/viewDetails'
import AuthenticationService from '../components/Security/AuthenticationService'
import CommonLoader from '../components/Alerts/CommonLoader'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import { checkAccess, getPermission } from '../actions/permissions'
import { bindActionCreators } from 'redux'
class ViewDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      showCommonLoader: true,
      deviceUid: ''
    }
    // Initilizing the services.
    this.authService = new AuthenticationService(Config.authBaseUrl)
    // Binding the methods
    this.displayRemoteSystemActions = this.displayRemoteSystemActions.bind(this)
    props.getPermission()
  }

  componentWillMount () {
    const params = new URLSearchParams(this.props.history.location.search)
    let deviceUid = params.get('duid') ? params.get('duid') : null
    this.setState({ deviceUid })
    this.setState({ showCommonLoader: true })
    this.props.getStoreDetails(deviceUid, () => {
      this.setState({ showCommonLoader: false })
    })
  }

  displayRemoteSystemActions (systemStatus) {
    // Checking is the device is online.
    if (systemStatus && systemStatus.Device_IsActive === 1) {
      // Check for the reboot permission for the user or is the logged in user is admin.
      if (checkAccess(CommonConstants.userPermissions.PerformDeviceRestart) || this.authService.isAdmin()) {
        return (
          <RemoteSystemActions systemActions={this.props.storeViewDetails} deviceUid={this.state.deviceUid} history={this.props.history} />
        )
      }
    }
  }
  render () {
    if (this.props.storeViewDetails !== undefined) {
      return (<div>
        <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
        <div className={'viewDetailsSection ' + (this.state.showCommonLoader ? 'hide' : '')}>
          <div className='device_details row'>
            <div className='col-sm-12 col-md-6 col-lg-5' >
              <SystemStatus data={this.props.storeViewDetails} history={this.props.history} userPermissions={checkAccess(CommonConstants.userPermissions.RemoteConnect)} />
              {this.displayRemoteSystemActions(this.props.storeViewDetails.systemStatus[0])}
            </div>
            <div className='col-sm-12 col-md-6 col-lg-7'>
              {this.state.currentLanguage === 1 || this.props.storeViewDetails.systemStatus[0].Device_Name === 'CIB' || !this.props.storeViewDetails.systemStatus[0].Device_Name ? '' : <SystemSettings data={this.props.storeViewDetails} />}
            </div>
          </div>
        </div>
      </div>
      )
    } else {
      return (
        <div>Loading</div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    storeViewDetails: state.viewDetails.storeViewDetails
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getPermission: getPermission,
      getStoreDetails: getStoreDetails
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(ViewDetails)



// WEBPACK FOOTER //
// ./src/containers/ViewDetails.js